module.exports = __webpack_public_path__ + "img/horizontal_4_6_6005.99ca7a46.png";